import React from "react";
import Svg, {
  Circle,
  G,
  Path,
  Defs,
  ClipPath,
  SvgProps,
} from "react-native-svg";

const ExpertIcon = (props: SvgProps) => {
  return (
    <Svg width="48" height="48" fill="none">
      <Circle cx="24" cy="24" r="24" fill="#FFF3C2" />
      <G clipPath="url(#a)">
        <Path
          fill="#8C6500"
          d="M23.875 24.15a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Zm-.524 3.628-.654-1.09a.561.561 0 0 1 .482-.85H24.568c.435 0 .706.477.481.85l-.654 1.09 1.175 4.356 1.265-5.165c.07-.285.345-.47.63-.397a5.672 5.672 0 0 1 4.285 5.498 1.08 1.08 0 0 1-1.08 1.08h-4.633a.554.554 0 0 1-.204-.039l.01.039h-3.937l.01-.039a.568.568 0 0 1-.203.039h-4.634c-.594 0-1.079-.486-1.079-1.08a5.67 5.67 0 0 1 4.285-5.498.526.526 0 0 1 .63.397l1.265 5.165 1.175-4.356h-.004Z"
        />
      </G>
      <Defs>
        <ClipPath id="a">
          <Path fill="#fff" d="M16 15.15h15.75v18H16v-18Z" />
        </ClipPath>
      </Defs>
    </Svg>
  );
};

export default ExpertIcon;
